export enum TokenType {
	INITIAL = 'INITIAL',
	EVALUATION = 'EVALUATION',
	/** Usa EVALUATION si ya está disponible, si no cae a INITIAL.
	 *  Para endpoints llamados tanto antes como después del OTP (ej. ofertasMotor). */
	EVALUATION_OR_INITIAL = 'EVALUATION_OR_INITIAL',
	NONE = 'NONE',
}

export const endpointTokenCatalog: Array<{
	pathPattern: RegExp;
	method: string;
	tokenType: TokenType;
}> = [
	// ── Transversal ───────────────────────────────────────────────────────────
	// AnalyticalLogsService.sendLog() se dispara desde casi todas las pantallas,
	// antes y después del OTP.
	{ pathPattern: /\/logDigitalAnalitica/, method: 'POST', tokenType: TokenType.EVALUATION_OR_INITIAL },

	// ── Paso 0 — Carga de folio / proceso ────────────────────────────────────
	{ pathPattern: /\/rutas_proceso/, method: 'GET', tokenType: TokenType.INITIAL },
	{ pathPattern: /\/initialInformation/, method: 'GET', tokenType: TokenType.INITIAL },
	// get_products (catálogo de producto digital: total_pasos, subproducto, segmento).
	// OnboardingProcessFlowService lo llama en la carga inicial y también al reanudar
	// desde ine-back, photo-proof y credit-status, es decir después del OTP.
	{ pathPattern: /\/get_products/, method: 'POST', tokenType: TokenType.EVALUATION_OR_INITIAL },
	// ofertasMotor se llama en paso 0 (INITIAL) y pasos 7 y 9 (EVALUATION)
	{ pathPattern: /\/ofertasMotor/, method: 'GET', tokenType: TokenType.EVALUATION_OR_INITIAL },

	// ── Paso 1 — Simulador de crédito ────────────────────────────────────────
	// simulate_payment: usa siempre el token INITIAL (antes del OTP en el
	// simulador de crédito y también en el paso 9)
	{ pathPattern: /\/simulate_payment/, method: 'POST', tokenType: TokenType.INITIAL },

	// ── Pasos 1-2 — Consulta de CURP ─────────────────────────────────────────
	{ pathPattern: /\/validate_data_renapo/, method: 'POST', tokenType: TokenType.INITIAL },
	{ pathPattern: /\/validar_curp_veridoc/, method: 'POST', tokenType: TokenType.INITIAL },
	{ pathPattern: /\/socio_curp/, method: 'GET', tokenType: TokenType.INITIAL },

	// ── Paso 2 — Datos personales ────────────────────────────────────────────
	{ pathPattern: /\/catalogo_cp/, method: 'POST', tokenType: TokenType.INITIAL },
	{ pathPattern: /\/provincias/, method: 'GET', tokenType: TokenType.INITIAL },
	{ pathPattern: /\/ciudades/, method: 'GET', tokenType: TokenType.INITIAL },
	// parroquias también se consume después del OTP, en collect-card-form
	// (credit-status, paso 11)
	{ pathPattern: /\/parroquias/, method: 'GET', tokenType: TokenType.EVALUATION_OR_INITIAL },
	{ pathPattern: /\/schoolCatalog/, method: 'POST', tokenType: TokenType.INITIAL },
	{ pathPattern: /\/clasProfesion/, method: 'POST', tokenType: TokenType.INITIAL },
	{ pathPattern: /\/subClasProfesion/, method: 'POST', tokenType: TokenType.INITIAL },
	{ pathPattern: /\/salaryRanges/, method: 'POST', tokenType: TokenType.INITIAL },
	{ pathPattern: /\/presolicitudes/, method: 'POST', tokenType: TokenType.INITIAL },
	{ pathPattern: /\/guardar_datos_contacto/, method: 'POST', tokenType: TokenType.INITIAL },
	{ pathPattern: /\/obtener_datos_contacto/, method: 'GET', tokenType: TokenType.INITIAL },
	{ pathPattern: /\/insertarDomicilio/, method: 'POST', tokenType: TokenType.INITIAL },
	// presolicitud_datos_credito: usa siempre el token INITIAL (paso 2 antes del
	// OTP y paso 9 después del OTP)
	{ pathPattern: /\/presolicitud_datos_credito/, method: 'POST', tokenType: TokenType.INITIAL },

	// ── Paso 3 — OTP ─────────────────────────────────────────────────────────
	{ pathPattern: /\/getOtp/, method: 'POST', tokenType: TokenType.INITIAL },
	// validaOTP: validación interna del OTP (flujos TDC e inversión). El flujo de
	// crédito la omite y valida vía evaluation_steps_auths.
	{ pathPattern: /\/validaOTP/, method: 'POST', tokenType: TokenType.INITIAL },
	// evaluation_steps_auths gestiona su propio header Authorization (NONE por defecto)

	// ── Paso 4 — Identidad (Incode) ──────────────────────────────────────────
	{ pathPattern: /\/obtener_token_identidad/, method: 'GET', tokenType: TokenType.EVALUATION },
	{ pathPattern: /\/insertar_identidad_socio/, method: 'POST', tokenType: TokenType.EVALUATION },

	// ── Paso 4 — Captura INE reverso ─────────────────────────────────────────
	{ pathPattern: /\/saveInfoIne/, method: 'POST', tokenType: TokenType.EVALUATION },

	// ── Paso 5 — Comprobante de domicilio ────────────────────────────────────
	{ pathPattern: /\/updateCompAdress/, method: 'POST', tokenType: TokenType.EVALUATION },

	// ── Paso 7 — Video selfie ────────────────────────────────────────────────
	{ pathPattern: /\/validaciones_identidad/, method: 'PUT', tokenType: TokenType.EVALUATION },
	{ pathPattern: /\/evaluateOnboardingIdentity/, method: 'GET', tokenType: TokenType.EVALUATION },
	{ pathPattern: /\/evaluate_tdc/, method: 'GET', tokenType: TokenType.EVALUATION },

	// ── Paso 8 — Generar contraseña ──────────────────────────────────────────
	{ pathPattern: /\/savePassword/, method: 'POST', tokenType: TokenType.EVALUATION },

	// ── Paso 9 — Confirmación de oferta ──────────────────────────────────────
	{ pathPattern: /\/generarEvaluacion/, method: 'POST', tokenType: TokenType.EVALUATION },
	{ pathPattern: /\/oferta_existente/, method: 'PUT', tokenType: TokenType.EVALUATION },
	{ pathPattern: /\/getPagare/, method: 'POST', tokenType: TokenType.EVALUATION },
	{ pathPattern: /\/getCaratulaCredit/, method: 'POST', tokenType: TokenType.EVALUATION },
	// forms_visualization_auths: emite el token para obtenerPlantillaDocumento;
	// requiere el token de EVALUATION.
	{ pathPattern: /\/forms_visualization_auths/, method: 'POST', tokenType: TokenType.EVALUATION },
	// obtenerPlantillaDocumento queda fuera del catálogo a propósito: lleva el
	// token emitido por forms_visualization_auths, puesto manualmente.

	// ── Paso 10 — Firma ──────────────────────────────────────────────────────
	{ pathPattern: /\/insertarSolicitud/, method: 'POST', tokenType: TokenType.EVALUATION },

	// ── Paso 10 — Felicidades ────────────────────────────────────────────────
	{ pathPattern: /\/voucherDigital/, method: 'POST', tokenType: TokenType.EVALUATION },

	// ── Paso 11 — Seguimiento de estatus ─────────────────────────────────────
	{ pathPattern: /\/getProcessDigital/, method: 'POST', tokenType: TokenType.EVALUATION },

	// Fuera del catálogo a propósito (la cabecera Authorization ya transporta el
	// token PLD): obtenerListaInterna y api/socios/{id_socio}/coincidencias_listas.
];

export function getTokenTypeForEndpoint(path: string, method: string): TokenType {
	const match = endpointTokenCatalog.find(
		entry => entry.pathPattern.test(path) && entry.method === method
	);
	return match?.tokenType ?? TokenType.NONE;
}
